import React from "react";
import "../css/HeroScene.css";
/*import band from "../images/pngs/dys_life_preserver.png";*/
import band from "../images/pngs/DYS in FLAG.png";
import oceanBack from '../images/backgrounds/ocean2.webp';
import oceanFront from '../images/backgrounds/ocean2.webp';
import cloudImg from "../images/backgrounds/White_Small_Cloud_PNG.png";
import cloudImg2 from "../images/backgrounds/White_Small_Cloud2_PNG.png";
import frond1 from "../images/pngs/frond.png";
import frond2 from "../images/pngs/frond3.png";



export default function HeroScene() {
    return (
        <div className="scene">
            {/* Sky */}
            <div className="sky"></div>
            <div className="clouds">
                <img src={cloudImg} className="cloud c1" alt="cloud" />
                <img src={cloudImg} className="cloud c2" alt="cloud" />
                <img src={cloudImg} className="cloud c3" alt="cloud" />
                <img src={cloudImg2} className="cloud2 c4" alt="cloud" />
                <img src={cloudImg2} className="cloud2 c5" alt="cloud" />
                <img src={cloudImg} className="cloud c6" alt="cloud" />
                <img src={cloudImg2} className="cloud c7" alt="cloud" />
                <img src={cloudImg2} className="cloud2 c8" alt="cloud" />
            </div>



            <div className="palm-container">
                <img src={frond1} className="palm palm-left" alt="Palm frond left" />
                <img src={frond2} className="palm palm-right" alt="Palm frond right" />
            </div>      


            {/* Ocean layers */}
            <div className="ocean-wrapper">
                <div
                    className="ocean-slide"
                    style={{ backgroundImage: `url(${oceanBack})` }}
                />
                <div
                    className="ocean-slide"
                    style={{ backgroundImage: `url(${oceanFront})` }}
                />
            </div>

            {/* Floating Band */}
            <img
                src={band}
                alt="Dirty Yachtin’ Scoundrels"
                className="band-floating"
            />

            {/* Bubble Spray Overlay */}
            <div className="ocean-spray">
                {Array.from({ length: 15 }).map((_, i) => (
                    <span key={i} className="bubble"
                        style={{
                            '--x': `${Math.random() * 20 - 10}px`,
                            '--y': `${Math.random() * -50}px`,
                            '--x2': `${Math.random() * 30 - 15}px`,
                            '--y2': `${Math.random() * -80}px`,
                            '--x3': `${Math.random() * 40 - 20}px`,
                            '--y3': `${Math.random() * -100}px`,
                            '--s': (Math.random() * 0.7 + 0.5),
                            '--r': `${Math.random() * 20 - 10}deg`
                        }}
                    />
                ))}
            </div>



        </div>
    );
}
